export default {
      id: "as-accessible-accommodation-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-accessible-accommodation",
      toString: function () {
        return this.url;
      }
    }